import React from 'react';

export function SettingRowColumn({ children, position, ...rest }) {
  return (
    <div className={`setting-row-column ${position}`} {...rest}>
      {children}
    </div>
  );
}

SettingRowColumn.Span = function ({ text }) {
  return <h5 className='settings-select-card-title'>{text}</h5>;
};

SettingRowColumn.AnimationSwitch = function ({ isAnimationsOn }) {
  return <div className={`switcher ${isAnimationsOn ? 'active' : ''}`} />;
};

SettingRowColumn.Range = function ({
  value,
  width,
  rangeColorType,
  onChange,
  min = 0,
  max = 1,
  step = 0.1,
}) {
  return (
    <div className={`f-c-min-max-line ${rangeColorType}`}>
      <div className='range-wrp'>
        <input
          min={min}
          max={max}
          step={step}
          value={value}
          type='range'
          className='inp-range-s'
          onChange={onChange}
        />
      </div>
      <div className='inp-range-line-wr' style={{ width: `${width}%` }}>
        <div className='inp-range-line-sp' />
      </div>
    </div>
  );
};
SettingRowColumn.Icon = function ({ iconName, onClick }) {
  return <i onClick={onClick} className={`${iconName} setting-icon`} />;
};

SettingRowColumn.Cards = function ({ children }) {
  return <div className='setting-cards'>{children}</div>;
};
SettingRowColumn.Card = function ({ isActive, onClick, imgType, cardType = '' }) {
  return (
    <div
      className={`setting-card ${imgType} ${cardType} ${isActive ? 'active' : ''}`}
      onClick={() => onClick()}
    />
  );
};
